import { render, staticRenderFns } from "./ProjectDetailsPage.vue?vue&type=template&id=4dfb3dc8&scoped=true"
import script from "./ProjectDetailsPage.vue?vue&type=script&lang=js"
export * from "./ProjectDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetailsPage.vue?vue&type=style&index=0&id=4dfb3dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfb3dc8",
  null
  
)

export default component.exports